import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type OfferOption = 'neon' | 'combo';
export function UpsellBox() {
  const [selected, setSelected] = useState<OfferOption>('combo');
  const offers = {
    neon: {
      label: 'Oferta principal',
      title: 'Neon Flex Digital',
      description: <div className="space-y-2" data-id="element-233">
          <p className="font-bold text-[13px] text-[#1B00FF]" data-id="element-234">
            🚀 Todo para dominar el Neon Flex:
          </p>
          <ul className="space-y-1 list-disc list-inside" data-id="element-235">
            <li className="text-[14px]" data-id="element-236">Libro Principal NeonFlex Digital</li>
            <li className="text-[14px]" data-id="element-237">6 Bonus Exclusivos</li>
          </ul>
          <p className="font-medium italic" data-id="element-238">Ideal para empezar desde cero.</p>
        </div>,
      price: '$19.990',
      oldPrice: '$39.990',
      image: 'https://cdn.magicpatterns.com/uploads/uWUafb1NTfvXy4rEiHyzsm/111111.webp',
      checkoutUrl: 'https://www.digital-factory.store/cart/46890834722900:1'
    },
    combo: {
      label: 'Combo especial',
      title: 'Neon Flex + Mesas y Espejos Infinitos',
      description: <div className="space-y-2" data-id="element-239">
          <p className="font-bold text-[13px] text-[#1D12EE]" data-id="element-240">
            💎 Accedé a 2 capacitaciones completas por una diferencia mínima:
          </p>
          <ul className="space-y-1 list-disc list-inside" data-id="element-241">
            <li className="text-[14px]" data-id="element-242">Neon Flex + 6 Bonus</li>
            <li className="text-[14px]" data-id="element-243">Mesas y Espejos Infinitos + 5 Bonus</li>
          </ul>
          <p className="font-medium italic" data-id="element-244">
            Más valor. Más contenido. Más oportunidades.
          </p>
        </div>,
      price: '$25.990',
      oldPrice: '$55.990',
      image: 'https://cdn.magicpatterns.com/uploads/555GytoS73nwsRvP8qoszs/ChatGPT_Image_29_may_2026,_15_28_42.webp',
      checkoutUrl: 'https://www.digital-factory.store/cart/46918176309332:1',
      popular: true
    }
  };
  return <section id="pricing" className="py-20 px-4 relative z-10 bg-transparent pt-[8px] pb-[8px]" data-id="element-245">
      <div className="max-w-[720px] mx-auto p-[18px] rounded-[18px] bg-[#f3f4f6] border border-gray-300 shadow-[0_0_28px_rgba(0,0,0,0.1)]" data-id="element-246">
        <h3 className="text-center text-gray-900 text-[22px] mb-[14px] font-black tracking-tight" data-id="element-247">
          Elegí tu oferta especial
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[12px]" data-id="element-248">
          {/* Neon Option */}
          <div onClick={() => setSelected('neon')} className={`relative p-[14px] rounded-[14px] border cursor-pointer transition-all duration-250 flex flex-col ${selected === 'neon' ? 'bg-white border-[#00f0ff] shadow-[0_0_22px_rgba(0,240,255,0.25)] -translate-y-[1px]' : 'bg-white/50 border-gray-200 hover:border-gray-300'}`} data-id="element-249">
            <span className="font-bold uppercase tracking-wider text-[12px] text-[#C90EEE]" data-id="element-250">
              {offers.neon.label}
            </span>
            <h4 className="text-gray-900 text-[17px] my-[4px] font-black leading-tight" data-id="element-251">
              {offers.neon.title}
            </h4>
            <div className="text-[12px] leading-[1.3] mb-[8px] flex-grow text-[#00080F]" data-id="element-252">
              {offers.neon.description}
            </div>
            <div className="mb-3" data-id="element-253">
              <span className="text-sm line-through block leading-none mb-1 text-[#E00606]" data-id="element-254">
                {offers.neon.oldPrice}
              </span>
              <strong className="block text-[22px] font-black leading-none text-[#0ABF16]" data-id="element-255">
                {offers.neon.price}
              </strong>
            </div>
            <button className={`${`w-full py-1.5 rounded-lg font-bold text-xs transition-all ${selected === 'neon' ? 'bg-[#00f0ff] text-white shadow-lg' : 'bg-gray-100 text-gray-400'}`} bg-[#0CD813]`} data-id="element-256">
              {selected === 'neon' ? 'SELECCIONADO' : 'SELECCIONAR'}
            </button>
          </div>

          {/* Combo Option */}
          <div onClick={() => setSelected('combo')} className={`relative p-[14px] rounded-[14px] border cursor-pointer transition-all duration-250 flex flex-col ${selected === 'combo' ? 'bg-white border-[#00f0ff] shadow-[0_0_22px_rgba(0,240,255,0.25)] -translate-y-[1px]' : 'bg-white/50 border-gray-200 hover:border-gray-300'}`} data-id="element-257">
            <div className="absolute -top-[10px] right-[10px] text-gray-900 px-[8px] py-[3px] rounded-full font-black shadow-[0_0_10px_rgba(251,191,36,0.3)] z-10 bg-[#F5F52C] text-[12px]" data-id="element-258">
              ★ Más elegido
            </div>

            <span className="font-bold uppercase tracking-wider text-[12px] text-[#B404F3]" data-id="element-259">
              {offers.combo.label}
            </span>
            <h4 className="text-gray-900 text-[17px] my-[4px] font-black leading-tight" data-id="element-260">
              {offers.combo.title}
            </h4>
            <div className="text-[12px] leading-[1.3] mb-[8px] flex-grow text-[#020814]" data-id="element-261">
              {offers.combo.description}
            </div>
            <div className="mb-3" data-id="element-262">
              <span className="text-sm line-through block leading-none mb-1 text-[#E60E27]" data-id="element-263">
                {offers.combo.oldPrice}
              </span>
              <strong className="block text-[22px] font-black leading-none text-[#0CC51F]" data-id="element-264">
                {offers.combo.price}
              </strong>
            </div>
            <button className={`${`w-full py-1.5 rounded-lg font-bold text-xs transition-all ${selected === 'combo' ? 'bg-[#00f0ff] text-white shadow-lg' : 'bg-gray-100 text-gray-400'}`} bg-[#09DC25]`} data-id="element-265">
              {selected === 'combo' ? 'SELECCIONADO' : 'SELECCIONAR'}
            </button>
          </div>
        </div>

        <div className="mt-[16px] relative rounded-[16px] overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] bg-white" data-id="element-266">
          <AnimatePresence mode="wait" data-id="element-267">
            <motion.img key={selected} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} src={offers[selected].image} alt="Oferta seleccionada" className="w-full h-auto block mx-auto" data-id="element-268" />
          </AnimatePresence>
        </div>

        <div className="mt-8" data-id="element-269">
          <a href={offers[selected].checkoutUrl} className="block w-full py-5 rounded-xl bg-gradient-to-r from-[#ec4899] to-[#8b5cf6] text-white text-center font-black text-xl uppercase tracking-widest shadow-[0_10px_30px_rgba(236,72,153,0.3)] hover:scale-[1.01] active:scale-[0.98] transition-all" data-id="element-270">
            ¡COMPRAR AHORA!
          </a>
          <p className="text-center text-gray-400 text-xs mt-4 font-bold uppercase tracking-widest" data-id="element-271">
            🔒 Pago Seguro • Acceso Inmediato • 7 Días de Garantía
          </p>
        </div>

        {/* Mercado Pago Trust Image */}
        <div className="mt-8 -mx-[18px] -mb-[18px] border-t border-gray-200 overflow-hidden rounded-b-[18px]" data-id="element-272">
          <img src="https://cdn.magicpatterns.com/uploads/uUsHE36gY1b2kZZniihejK/ChatGPT_Image_29_may_2026,_16_20_08.webp" alt="Mercado Pago Trust" className="w-full h-auto block" data-id="element-273" />
        </div>
      </div>
    </section>;
}